import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Map from "@babel/runtime-corejs3/core-js/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import template from './select.vdt';
import { eachChildren, isComponentVNode } from '../utils';
import { isNullOrUndefined } from 'intact-shared';
import { Option } from './option';
import { OptionGroup } from './group';
import { useFilterable } from './useFilterable';
import { useLabel } from './useLabel';
import { BaseSelect } from './base';
import { _$ } from '../../i18n';
import { useEqualWidth } from './useEqualWidth';
var typeDefs = _extends({}, BaseSelect.typeDefs, {
  filter: Function,
  searchable: Boolean,
  creatable: Boolean,
  labelMap: _Map,
  card: Boolean,
  autoDisableArrow: Boolean
});
var defaults = function defaults() {
  return _extends({}, BaseSelect.defaults(), {
    labelMap: new _Map()
  });
};
export var Select = /*#__PURE__*/function (_BaseSelect) {
  _inheritsLoose(Select, _BaseSelect);
  function Select() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _BaseSelect.call.apply(_BaseSelect, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.filterable = useFilterable(_this.input.keywords);
    _this.label = useLabel();
    return _this;
  }
  var _proto = Select.prototype;
  _proto.init = function init() {
    _BaseSelect.prototype.init.call(this);
    useEqualWidth();
  };
  _proto.getPlaceholder = function getPlaceholder() {
    var _this$get = this.get(),
      placeholder = _this$get.placeholder,
      creatable = _this$get.creatable,
      filterable = _this$get.filterable;
    return isNullOrUndefined(placeholder) ? creatable && filterable ? _$('请输入或选择') : _$('请选择') : placeholder;
  };
  _proto.getLabel = function getLabel() {
    return this.label.getLabel();
  };
  _proto.getAllShowedValues = function getAllShowedValues(children) {
    var values = [];
    var loop = function loop(children) {
      eachChildren(children, function (vNode) {
        if (isComponentVNode(vNode, Option)) {
          var props = vNode.props;
          if (!props.disabled) {
            values.push(props.value);
          }
        } else if (isComponentVNode(vNode, OptionGroup)) {
          loop(vNode.props.children);
        }
      });
    };
    loop(children);
    return values;
  };
  return Select;
}(BaseSelect);
Select.template = template;
Select.typeDefs = typeDefs;
Select.defaults = defaults;